module.exports = {
    label: {
        note: 'Note',
        imageNote: 'Max 6 Images can be uploaded.',
        sendNote: 'Do you want to send a note to Patient?',
        repeatMonths: 'How many repeats?',
       // imageNote: 'Max 6 (Images/pdf) files can be uploaded.',
        maxFiles: 'Maximum six files can be uploaded',
        pdfNote: 'Max 1 Pdf can be uploaded.',
        imgError: 'Please choose at least one image file',
        pdfError: ' Please choose a Pdf file',
        fileError: 'Please choose at least one (Image/Pdf) file',
        scriptCreated: 'Script (images/pdf) files uploaded successfully',
        eScriptCreated: 'eScript created successfully',
        sendNoteToNurse: 'Note for Patient',
        smsSent: 'SMS sent successfully.',
        enterNote: 'Note for Patient',
        noteRequired: 'Please enter note',
        nameError: 'Please enter patient name',
        pharmaNameError: 'Please enter pharmacist name',
        patientDetails: 'Patient Details',
        patientName: 'Name of Patient',
        mobileNumber: 'Mobile Number',
        emailId: 'Email ID',
        idNumber: 'ID number / Passport no',
        icdCode: 'ICD10 codes',
        patientMinor: 'Is Patient a Minor?',
        parentName: 'Name of Parent/Guardian',
        parentIDNumber: 'ID No. / Passport no of Parent or Guardian',
//        medicineRequired: 'Medicine required',
        medicineRequired: 'Medicine requested by patient via request form',
        specialInstructions: 'Special instructions/other',
        dob: 'DOB',
        gender: 'Gender',
        bloodGroup: 'Blood Group',
        address: 'Address',
        attachments: "Attach PDF",
        chooseImage: 'Choose Images',
        mobileErrorPharma: "Pharmacist mobile number should start with 0",
        mobileError: "Patient mobile number should start with 0",
        onlyImage: "Only image files are allowed",
        onlyPdf: "Only pdf file is allowed",
        mobileRequired: "The mobile number is required",
        selectOne: "Please enter patient mobile number or email id",
        selectOnePharma: "Please enter pharmacist mobile number or email id",
        pharmacistDetails: 'Pharmacist Details',
        pharmacistName: 'Name of Pharmacist',
        tariff: 'Tariff',
        prescription: 'Prescription',
        signature: 'Signature',
        mobileExample: "eg. 0XXXXXXXXX",
        email: "The email is required",
        tariffZero: "The Tariff amount should be less than 0",
        noSignature: "No Signature available",
        smsContent: "SMS Content",
        placeholder: {
            enterName: 'Enter Name',
            enterMobileNumber: 'Enter Mobile Number',
            enterEmailId: 'Enter Email ID',
            enterIDNumber: 'Enter ID Number / Passport no',
            enterIcdCode: 'Enter ICD10 codes',
            selectGender: 'Select Gender',
            selectBloodGroup: 'Select Blood Group',
            enterAddress: 'Enter Address',
            enterTariff: '150',
            date: "DD/MM/YY",
            enterdescription: 'Prescribe here',
        },
        modal: {
            title: 'Share',
            shareScript: 'Share Script Via Email',
            shareScriptSms: 'Share Script Via SMS',
            sendSmsTitle: 'Send Sms',
            shareEScript: 'Share eScript Via Email',
            copyScript: 'Copy Script Link',
            copyEScript: 'Copy eScript Link',
        },
        buttons: {
            createScript: 'Create a Script',
            send: 'Send',
            eCreateScript: 'Create an eScript',
            submit: 'Submit',
        },
        validationMessages: {
            tariffRequired:'Please enter tariff amount',
            tariffMax:'Tariff amount must be between 0 and 100000',
            prescriptionRequired: 'Please enter prescription',
            mobileNumberRequired: 'Please enter mobile number',
            startsWithZero: 'Mobile number should start with 0',
            medicineRequired: 'Please enter the required medicines',
            mobilenumLength:'Patient mobile number must be 10 digits long',
            mobilenumLengthPharma:'Pharmacist mobile number must be 10 digits long',
            emailFormat:'Please enter valid patient email',
            emailFormatPharma:'Please enter valid pharmacist email',
            repeatMonthsRequired: 'Please select repeat duration'
        },
    }
};
